<template>
  <div class="bienvenida-page">
            <p class="versiculo-referencia-fija" ref="versiculoRef"> </p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <br>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Sábado</p>
      <p class="fecha-dia-numero" ref="numeroRef">24</p>
      <p class="fecha-mes" ref="mesRef">OCTUBRE</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
          A los &nbsp;"&nbsp; <span class="letra-quince"> 15 años</span> &quot;&nbsp; el alma se vuelve un jardín diverso y colorido,
arropado de emociones y promesas de un lindo porvenir. <br> Esta
noche, entre hilos de seda y susurros de naturaleza, celebramos el
arte de crecer; y mi historia, que hoy se viste de gala, está lista para
recibir la bendición de un horizonte infinito.      </p>
        </div>
      </div>
    </div>

    <!-- Grupo decorativo 1 -->
    <div class="disco-group disco1-group">
      <img src="@/assets/ramas.png" alt="estrellas" class="estrellas" ref="estrella1Ref" />
      <img src="@/assets/f.png" alt="disco" class="disco" ref="disco1Ref" />
    </div>

    <!-- Grupo decorativo 2 -->
    <div class="disco-group disco2-group">
      <img src="@/assets/ramas.png" alt="estrellas" class="estrellas" ref="estrella2Ref" />
      <img src="@/assets/f.png" alt="disco" class="disco" ref="disco2Ref" />
    </div>

    <!-- Grupo decorativo 3 -->
    <div class="disco-group disco3-group">
      <img src="@/assets/ramas.png" alt="estrellas" class="estrellas" ref="estrella3Ref" />
      <img src="@/assets/f.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>
        <div class="rasgado rasgado-inferior"></div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);

    const estrella1Ref = ref(null);
    const estrella2Ref = ref(null);
    const estrella3Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(el);
    };

    onMounted(() => {
      // Texto
      animateOnScroll(granDiaRef.value, () =>
        gsap.fromTo(granDiaRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8 })
      );
      animateOnScroll(diaSemanaRef.value, () =>
        gsap.fromTo(diaSemanaRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 })
      );
      animateOnScroll(numeroRef.value, () =>
        gsap.fromTo(numeroRef.value, { opacity: 0, y: -80, scale: 0.7 }, { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'bounce.out' })
      );
      animateOnScroll(mesRef.value, () =>
        gsap.fromTo(mesRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.2 })
      );
      animateOnScroll(anioRef.value, () =>
        gsap.fromTo(anioRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.3 })
      );
      animateOnScroll(mensajeRef.value, () =>
        gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1 })
      );
      animateOnScroll(versiculoTextRef.value, () =>
        gsap.fromTo(versiculoTextRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1 })
      );
      animateOnScroll(versiculoRef.value, () =>
        gsap.fromTo(versiculoRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1 })
      );

      // Grupos disco + estrella con timeline
 const animateDiscoConEstrella = (discoEl, estrellaEl, delay = 0) => {
  const tl = gsap.timeline({ delay });

  // 1) CAE DESDE EL CIELO + APARECE
  tl.fromTo(
    discoEl,
    { opacity: 0, y: -150, scale: 0.9 },          // empieza más arriba
    { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: "bounce.out" } // rebota al llegar
  )
  // 2) ZOOM BONITO (pequeño latido elegante)
  .to(
    discoEl,
    { scale: 1.08, duration: 0.35, ease: "power2.out" }
  )
  .to(
    discoEl,
    { scale: 1, duration: 0.35, ease: "power2.inOut" }
  )
  // 3) ESTRELLA DESPUÉS DEL DISCO
  .fromTo(
    estrellaEl,
    { opacity: 0, scale: 0.5 },
    { opacity: 1, scale: 1, duration: 0.9, ease: "back.out(1.7)" },
    "+=0.1"
  );
};


      animateOnScroll(disco1Ref.value, () => animateDiscoConEstrella(disco1Ref.value, estrella1Ref.value));
      animateOnScroll(disco2Ref.value, () => animateDiscoConEstrella(disco2Ref.value, estrella2Ref.value, 0.2));
      animateOnScroll(disco3Ref.value, () => animateDiscoConEstrella(disco3Ref.value, estrella3Ref.value, 0.4));
    });

    return {
      mensaje,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,
      mensajeRef,
      versiculoTextRef,
      versiculoRef,
      disco1Ref,
      disco2Ref,
      disco3Ref,
      estrella1Ref,
      estrella2Ref,
      estrella3Ref
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  color: black;
  min-height: 80vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  
}

/* Fecha */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
    color:#536559;

}
.fecha-gran-dia {
  font-family: 'british', cursive;
  font-size: 32px;
  margin: 0;
}
.fecha-dia-semana {
  font-family: 'fecha', serif;
  font-size: 29px;
  margin: 10px 0;
}
.fecha-dia-numero {
  font-family: 'fecha', serif;
  font-size: 72px !important;
  font-weight: bold;
  margin: 0;
}
.fecha-mes {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 600;
  margin-top: 5px;
  letter-spacing: 2px;
}
.fecha-anio {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: italic;
  margin-top: 5px;
}

/* Contenido */
.bienvenida-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  line-height: 2;
  opacity: 0;
}
.versiculo-container {
  margin: 30px 20px 0 0px;
  text-align: center;
  opacity: 0;
}
.versiculo-texto {
  font: 16px 'quote', sans-serif;
  line-height: 1.8;
  color: #333;
    margin-left: 0 !important;
  margin-right: 0 !important;
}
.versiculo-referencia-fija {
  font: 24px 'nombre', sans-serif;
  color: #070707;
  
  margin-top: 40px;
  opacity: 0;
}
.letra-quince {
  font-family: 'british', cursive;
  font-size: 15px;
  color: #000;
  letter-spacing: 1px;
}

.letra-quince1 {
  font-family: 'british', cursive;
  font-size: 19px;
  color: #000;
  letter-spacing: 1px;
}
/* Discos con estrellas */
.disco-group {
  position: absolute;
  opacity: 1; /* <- asegúrate que no se oculte */
  pointer-events: none;
  z-index: 2;
}
.disco {
  width: 100px;
  height: 120px;

}
.estrellas {
  width: 100px;
  position: absolute;
  bottom: -85px;
  left: 0;
  transform: rotate(-10deg);
  opacity: 0;
}

/* Posiciones individuales */
.disco1-group {
  top: -5%;
  right: -15%;
}
.disco2-group {
  top: 30%;
  left: -10%;  width: 120px;
  height: 140px;
}
.disco3-group {
  bottom: -15%;
  left: -10%;
  z-index:10;
}
/* 🔽 RASGADO */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 60px;
  pointer-events: none;
  z-index: 5;
}

.rasgado-inferior {
  bottom: 0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
</style>